import { render, staticRenderFns } from "./banprompt.vue?vue&type=template&id=1460b56a&scoped=true"
import script from "./banprompt.vue?vue&type=script&lang=js"
export * from "./banprompt.vue?vue&type=script&lang=js"
import style0 from "./banprompt.vue?vue&type=style&index=0&id=1460b56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460b56a",
  null
  
)

export default component.exports